export enum EventType {
  Default = 0,
  Cinema = 1,
  Museum = 2,
  Motobike=3,
}



// WEBPACK FOOTER //
// ./src/app/models/event-type.enum.ts